export default "__VITE_ASSET__gbQpZ6J7__"